import routeAliases from '@/config/routeAliases';
import logger from '@/utils/logging';
import { getStepObjectFromRoute } from '@/utils/scenarioUtils';

/**
 * Dead ends for every scenarios. As soon as
 */
export default {
    methods: {
        setAppStateToError() {
            const { mode } = this.$store.state.settings;
            const stepObject = getStepObjectFromRoute(routeAliases[mode]?.error);

            if (mode && stepObject) {
                this.$router.replace(routeAliases[mode].error);
                this.$store.commit(
                    'scenario/setCurrentStep',
                    stepObject,
                );
            } else {
                /**
                 * In the case where the app doesn't even get a valid "mode" (normally provided by
                 * the backend), we trigger a generic error. This error cannot be contract-specific
                 * as the "mode" is missing.
                 */
                this.$store.commit(
                    'scenario/setCurrentStep',
                    {
                        content: {
                            headline: 'Fehler',
                            status_message: 'Es tut uns Leid! Leider konnte die Auftragserteilung im Moment nicht durchgeführt werden. Bitte probieren Sie zu einem späteren Zeitpunkt erneut, über den Ihnen zugesandten Link Ihren Vertrag mit uns abzuschließen.',
                        },
                    },
                );

                if (!this.$route || this.$route.path !== '/init-fehler') {
                    this.$router.replace('init-fehler');
                }
            }

            this.$store.commit('status/common/setIsAppLoading', false);
            this.$store.commit('status/common/setIsAppCriticalError', true);
        },
        setAppStateToSuccess() {
            const { mode } = this.$store.state.settings;

            this.$router.replace(routeAliases[mode].success);
            this.$store.commit(
                'scenario/setCurrentStep',
                getStepObjectFromRoute(routeAliases[mode].success),
            );
            this.$store.commit('status/common/setIsOfferSigned', true);
        },
        setAppStateToExpired() {
            /**
             * In the case where the contract is expired, the backend response doesn't contain any
             * contract data. Therefore the expired state is triggered before any scenario is
             * actually loaded.
             */
            this.$store.commit(
                'scenario/setCurrentStep',
                {
                    content: {
                        headline: 'Angebot abgelaufen',
                        status_message: 'Der Link zu Ihrem Angebot ist abgelaufen. Kontaktieren Sie bitte Ihren Heizungsplaner.',
                    },
                },
            );

            this.$router.replace('abgelaufen');

            this.$store.commit('status/common/setIsAppLoading', false);
        },
        setAppStateToOfferUnavailable(error) {
            /**
             * The backend doesn't say why an offer can't be loaded anymore, so the message has
             * to cover both "already accepted" and "expired". Reuses the off-scenario
             * "expired" route, which works with or without a loaded scenario.
             */
            this.$store.commit(
                'scenario/setCurrentStep',
                {
                    content: {
                        headline: 'Angebot nicht mehr verfügbar',
                        status_message: 'Dieses Angebot kann nicht mehr online angenommen werden, zum Beispiel weil es bereits angenommen wurde oder abgelaufen ist. Wurde es bereits angenommen, müssen Sie nichts weiter tun. Bei Fragen erreichen Sie unser Service-Team unter <a href="tel:08004200300">0800 4 200 300</a>.',
                    },
                },
            );
            // Keeps the customer here if they navigate back to a step of a loaded scenario.
            this.$store.commit('status/common/setIsOfferUnavailable', true);

            this.$router.replace('abgelaufen');

            this.$store.commit('status/common/setIsAppLoading', false);

            /**
             * Expected for the customer, so not reported as an error. Kept as one grouped
             * info event so that a spike (e.g. the backend refusing offers it should accept)
             * stays visible in Sentry.
             */
            logger(error, {
                level: 'info',
                fingerprint: ['maintenance-offer-unavailable'],
            });
        },
    },
};
